import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SignUrlInfo } from '../models/form/sign-url-info.model';
import { WorkFlowTaskInfo } from '../models/form/work-flow-task-info.model';
import { WorkFlowTaskSearchRequest } from '../models/form/work-flow-task-search-request.model';
import { WorkFlowTaskSummary } from '../models/form/work-flow-task-summary.model';
import { WorkFlowTask } from '../models/form/work-flow-task.model';
import { GlobalService } from '../providers/global.service';
import { Page } from '../providers/request/page.type';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class WorkFlowTaskService extends RequestService<WorkFlowTask> {
  static PATH = '/work/flow/task';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, WorkFlowTaskService.PATH, globalService.debugUrl);
  }

  getSignUrl(workFlowId: number) {
    return this.httpClient.get<SignUrlInfo>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/getSignUrlInfo/${workFlowId}`,
    );
  }

  listWorkFlowTaskByWorkOrderId(workOrderId: number) {
    return this.httpClient.get<WorkFlowTaskInfo[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/listWorkFlowTaskByWorkOrderId/${workOrderId}`,
    );
  }

  listWorkFlowTaskByCopyWorkOrderId(workOrderId: number) {
    return this.httpClient.get<WorkFlowTaskInfo[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${
        WorkFlowTaskService.PATH
      }/listWorkFlowTaskByCopyWorkOrderId/${workOrderId}`,
    );
  }

  listWorkFlowTaskByWorkFlowId(workFlowId: number) {
    return this.httpClient.get<WorkFlowTaskInfo[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/listWorkFlowTaskByWorkFlowId/${workFlowId}`,
    );
  }

  getTaskSummary() {
    return this.httpClient.get<WorkFlowTaskSummary[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/getTaskSummary`,
    );
  }

  searchWaitSign(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchWaitSign?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param,
    );
  }

  searchWaitEdit(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchWaitEdit?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param,
    );
  }

  searchWaitReply(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchWaitReply?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param,
    );
  }

  searchWaitCounterSign(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchWaitCounterSign?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param,
    );
  }

  searchWaitRead(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchWaitRead?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param,
    );
  }

  searchWaiting(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchWaiting?page=${page ? page : 0}&size=${
        size ? size : 20
      }`,
      param,
    );
  }

  searchRead(param: WorkFlowTaskSearchRequest, page?: number, size?: number) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchRead?page=${page ? page : 0}&size=${
        size ? size : 20
      }`,
      param,
    );
  }

  searchDone(param: WorkFlowTaskSearchRequest, page?: number, size?: number) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchDone?page=${page ? page : 0}&size=${
        size ? size : 20
      }`,
      param,
    );
  }

  searchInProgress(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number,
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskService.PATH}/searchInProgress?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param,
    );
  }
}
